import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { TFunction } from "i18next";
import translations, { translationKey } from "./translations";
import { Language } from "./common";

export const defaultNS = "translation";

export type { translationKey };

export const initI18n = async (language: Language): Promise<TFunction> => {
	return await i18next.use(initReactI18next).init({
		debug: true,
		lng: language,
		fallbackLng: "fi",
		defaultNS: defaultNS,
		ns: [defaultNS],
		resources: translations,
		interpolation: {
			escapeValue: false
		}
	});
};
